import { NsColumn } from '@britishgasenergy/react-nucleus';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsCard } from 'components/common/ns-card/NsCard';

export const testId = 'energySwitchStepsTestId';

export const EnergySwitchSteps = () => {
  return (
    <NsPanel testId={testId} decoration="blue">
      <div>
        <h2>Switching to us is super-simple</h2>
        <NsColumn hockeypitch="3">
          <NsCard heading="Get an accurate quote" decoration="dualFuel">
            To find the best deals for your home, personalise your quote based
            on how much energy your family uses.
          </NsCard>

          <NsCard
            heading="We'll take care of the switch for you"
            decoration="settings"
          >
            Once your order is confirmed, we&apos;ll let your current provider
            know you’ll be joining us.
          </NsCard>

          <NsCard heading="Provide meter readings" decoration="barGraph">
            To make sure you&apos;re only paying for what you use, you can
            easily send us your meter readings on our app or online.
          </NsCard>
        </NsColumn>
      </div>
    </NsPanel>
  );
};

export default EnergySwitchSteps;
